import { Type } from "@angular/core";

export class WidgetItem {
  constructor(public component: Type<any>, public name: string, public column: number = 0, public row: number = 0) {}
}
